// extracted by mini-css-extract-plugin
export default {"headerFixed":"header_headerFixed__TFD64","containerHeader":"header_containerHeader__qVEjC","logo":"header_logo__1XFsu"};